<template>
    <div>
        <container :active_path="'/invest/paper'" :plate="'投资军团'">
            <div class="base-warp">
                <div class="head">
                    <el-row>
                        <el-col :span="12">
                            <el-form :model="form" ref="form" label-width="80px" :inline="true" size="mini">
                                <el-form-item label="选择日期">
                                    <el-date-picker v-model="form.date" type="date" size="mini" placeholder="选择日期时间" value-format="M月d日">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="onsearch" icon="el-icon-search">搜索</el-button>
                                    <el-button type="success" @click="addpaper" icon="el-icon-plus">添加早报</el-button>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="12">
                            <el-button-group class="float-right">
                                <el-button type="success" size="mini" icon='el-icon-edit'>编辑</el-button>
                                <el-button type="danger" size="mini" icon='el-icon-delete'>删除</el-button>
                                <el-button type="info" size="mini" icon='el-icon-picture'>查看海报</el-button>
                            </el-button-group>
                        </el-col>
                    </el-row>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    size="mini"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column label="日期" prop="date" width="80" align="center"></el-table-column>
                        <el-table-column label="标题" prop="title" ></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="s">
                                <el-button-group >
                                    <el-button type="success" size="mini" icon='el-icon-edit' @click="editpaper(s.row)"></el-button>
                                    <!-- <el-button type="danger" size="mini" icon='el-icon-delete'></el-button>
                                    <el-button type="info" size="mini" icon='el-icon-picture'></el-button> -->
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
    </div>
</template>

<script>
import Container from '../../../components/container.vue'
export default {
    components: {
        Container,
    },
    data() {
        return {
            form: {
                date: '',
            },
            tabledata: [1],
            pageNo: 1,
            pagesize: 14,
            total: 0,
        }
    },
    mounted () {
        this.gettabledata();
    },
    methods: {
        editpaper(item) {
            var id = item._id['$oid'];
            this.$router.push({path: '/invest/paper/edit', query: {id}})
        },
        onsearch() {
            this.pageNo = 1;
            this.gettabledata();
        },
        gettabledata() {
            var params = {
                date: this.form.date,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.$api.getpaperlist(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        addpaper() {
            this.$router.push({path: '/invest/paper/edit'})
        },
        currentChange(page) {
            this.pageNo = page;
            this.gettabledata();
        },
    },
}
</script>

<style lang="scss" scoped>
.float-right{
    float: right;
}
</style>